import type { AccountSummary } from '@fruitful/types';

import { requestBuilder } from '../../../../http/RequestBuilder';
import { useRefetchHolisticSummaryMutationOptions } from '../useRefetchHolisticSummaryMutationOptions';

interface SetSpinwheelLoanQuilttAccountIdBody {
    userId: string;
    spinwheelAccountId: string;
    quilttAccountId?: string | null;
}

const useSetSpinwheelLoanQuilttAccountId = requestBuilder.mutation<
    AccountSummary | null,
    SetSpinwheelLoanQuilttAccountIdBody
>({
    endpoint:
        '/api/admin/holistic/accounts/spinwheel/loan/set-quiltt-account-id',
    method: 'PATCH',
});

export const useSetSpinwheelLoanQuilttAccountIdAndRefetch = (
    membershipId: string | null,
) => {
    const refetchHolisticSummaryMutationOptions =
        useRefetchHolisticSummaryMutationOptions(membershipId);

    const { mutateAsync } = useSetSpinwheelLoanQuilttAccountId(
        refetchHolisticSummaryMutationOptions,
    );

    const setSpinwheelLoanQuilttAccountIdAsync = async (
        body: SetSpinwheelLoanQuilttAccountIdBody,
    ) => {
        return await mutateAsync({
            body,
        });
    };

    return {
        setSpinwheelLoanQuilttAccountIdAsync,
    };
};
